import React, { useEffect, useState } from "react";

import CardTable from "./CardTable";
import Loader from "../Loader";
import { useSelector } from "react-redux";
import { isD365Integration, normalizeClassDimensionList } from "../../utils/d365Dimensions";

const CardsTable = ({ data }) => {
  const database = useSelector((state) => state.database);
  const [d365DimensionsList, setD365DimensionsList] = useState([]);
  const firstRow = Array.isArray(data) ? data[0] : null;
  const currentCompanyId =
    Number(database.currentCompany?.id) > 0 ? database.currentCompany.id : null;
  const selectedCompanyId =
    currentCompanyId ??
    database.currentShop?.company_id ??
    firstRow?.company_id;
  const selectedCompanyMeta = [
    ...(database.retail || []),
    ...(database.restoK || []),
  ].find((company) => String(company?.company_id) === String(selectedCompanyId));
  const d365Integration = isD365Integration(
    database.currentCompany,
    database.currentShop,
    selectedCompanyMeta,
    firstRow
  );

  useEffect(() => {
    let cancelled = false;

    const fetchDimensions = async () => {
      if (!d365Integration) {
        setD365DimensionsList([]);
        return;
      }

      const response = await fetch("https://reportapi.beesql.com/api/admin/retailr/report", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          company_id: database.currentCompany.id,
          shop_id: database.currentShop.shop_id ?? database.currentShop.area_id ?? 0,
          xoption: "D365DimensionsList",
        }),
      });
      const rows = await response.json();
      if (!cancelled) setD365DimensionsList(normalizeClassDimensionList(rows));
    };

    fetchDimensions().catch(() => {
      if (!cancelled) setD365DimensionsList([]);
    });

    return () => {
      cancelled = true;
    };
  }, [
    d365Integration,
    database.currentCompany.id,
    database.currentShop.shop_id,
    database.currentShop.area_id,
    selectedCompanyMeta,
    firstRow,
  ]);

  if (!data || data.length === 0 || !Array.isArray(data)) {
    return <Loader />;
  }

  const commonProps = {
    d365DimensionsList,
    isD365Integration: d365Integration,
  };

  return (
    <div>

      <div style={{ marginTop: "32px" }} />
      <CardTable
        title="Over/Short"
        data={data.filter((item) => item.what === "over_short")}
        what="over_short"
        shopShow={database.currentCompany.type === "RETAIL" ? true : false}
        {...commonProps}
      />
      <div style={{ marginTop: "32px" }} />
      <CardTable
        title="Tips"
        data={data.filter((item) => item.what === "tips")}
        what="tips"
        shopShow={database.currentCompany.type === "RETAIL" ? true : false}
        {...commonProps}
      />
       <div style={{ marginTop: "32px" }} />
        <CardTable
          title="CC Fees"
          data={data.filter((item) => item.what === "cc_fee")}
          what="cc_fee"
          shopShow={database.currentCompany.type === "RETAIL" ? true : false}
          {...commonProps}
        />

      <div style={{ marginTop: "32px" }} />
        <CardTable
          title="Golf CC Fees"
          data={data.filter((item) => item.what === "cc_fee_golf")}
          what="cc_fee_golf"
          shopShow={database.currentCompany.type === "RETAIL" ? true : false}
          {...commonProps}
        />

        <div style={{ marginTop: "32px" }} />
        <CardTable
          title="Miscellaneous"
          data={data.filter((item) => item.what === "misc")}
          what="misc"
          shopShow={database.currentCompany.type === "RETAIL" ? true : false}
          {...commonProps}
        />

      
      <div style={{ marginTop: "32px" }} />
        <CardTable
          title="Discount"
          data={data.filter((item) => item.what === "discount")}
          what="discount"
          shopShow={database.currentCompany.type === "RETAIL" ? true : false}
          {...commonProps}
        />


      {data.filter((item) => item.what === "fb_discount").length > 0 && (
        <>
          <div style={{ marginTop: "32px" }} />
          <CardTable
            title="Banquet Service Charge"
            data={data.filter((item) => item.what === "service_charge")}
            what="tips"
            shopShow={database.currentCompany.type === "RETAIL" ? true : false}
            {...commonProps}
          />
          <div style={{ marginTop: "32px" }} />
          <CardTable
            title="Sales Adjustment F&B"
            data={data.filter((item) => item.what === "fb_discount")}
            what="tips"
            shopShow={database.currentCompany.type === "RETAIL" ? true : false}
            {...commonProps}
          />
          <CardTable
            title="Discount"
            data={data.filter((item) => item.what === "discount")}
            what="tips"
            shopShow={database.currentCompany.type === "RETAIL" ? true : false}
            {...commonProps}
          />
        </>
      )}

      <div style={{ marginTop: "32px" }} />
      <CardTable
        title="Cash rounding"
        data={data.filter((item) => item.what === "cash_rounding")}
        what="cash_rounding"
        shopShow={database.currentCompany.type === "RETAIL" ? true : false}
        {...commonProps}
      />

      <div style={{ marginTop: "32px" }} />
      <CardTable
        title="Surcharge"
        data={data.filter((item) => item.what === "surcharge")}
        what="surcharge"
        shopShow={database.currentCompany.type === "RETAIL" ? true : false}
        {...commonProps}
      />

      <div style={{ marginTop: "32px" }} />
      <CardTable
        title="QB TRNS"
        data={data.filter(
          (item) => String(item.what || "").toLowerCase() === "qb_trns"
        )}
        what="qb_TRNS"
        shopShow={database.currentCompany.type === "RETAIL" ? true : false}
        {...commonProps}
      />
    </div>
  );
};

export default CardsTable;
